/* eslint-disable no-shadow */
/* eslint-disable camelcase */
import ProviderService from '@/services/ProviderService'

const state = {
    all: [],
    selected: 0,
}

const actions = {
    // eslint-disable-next-line object-curly-newline
    async fetch({ commit }, { platform, company_uuid, cc, api_key, lang }) {
        const providerService = new ProviderService(api_key)

        await providerService.get({
            platform,
            cc,
            company_uuid,
            lang,
        })
            .then((response) => {
                commit('UPDATE', response.data)
            })
            .catch((err) => console.log(err))
    },
    select({ commit }, id) {
        commit('SELECT', id)
    },
    reset({ commit }) {
        commit('SELECT', 0)
    },
}

const mutations = {
    SELECT(state, id) {
        Object.assign(state, { selected: id })
    },
    UPDATE(state, providers) {
        state.all = providers
    },
}

const getters = {
    selected(state) {
        return state.all.find((pack) => pack.uuid === state.selected)
    },
    getProviders(state) {
        return state.all.filter((provider) => provider.is_external === 0)
    },
    hasProviders(state) {
        return !!state.all.filter((provider) => provider.is_external === 0).length
    },
    getCarriers(state) {
        return state.all.filter((provider) => provider.is_external === 1)
    },
    hasCarriers(state) {
        return !!state.all.filter((provider) => provider.is_external === 1).length
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
